// src/views/Experience.jsx
import React, { useContext } from "react";
import { experiences } from "../constants";
import { ThemeContext } from "../themeProvider";
import { motion } from "framer-motion";

const Experience = () => {
  const theme = useContext(ThemeContext);
  const darkMode = theme.state.darkMode;

  return (
    <div
      id="experience"
      className={
        darkMode
          ? "bg-white min-h-screen py-20"
          : "bg-gray-900 min-h-screen py-20"
      }
    >
      <div className="max-w-6xl mx-auto px-6">
        <h2
          className={
            darkMode
              ? "text-5xl font-bold text-center mb-12 text-gray-800"
              : "text-5xl font-bold text-center mb-12 text-white"
          }
        >
          Experience
        </h2>

        <div className="relative flex flex-col space-y-20">
          <div className="hidden md:block absolute inset-y-0 left-1/2 transform -translate-x-1/2 w-1 bg-blue-400 z-0"></div>

          {experiences.map((exp, index) => (
            <div key={index} className="relative">
              <div className="hidden md:block absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10">
                <div className="w-5 h-5 rounded-full bg-blue-500 border-2 border-white"></div>
              </div>

              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ type: "spring", stiffness: 80, damping: 15 }}
                className={`relative md:w-[45%] w-full p-6 rounded-lg shadow-lg border-2 ${darkMode
                  ? "bg-gray-100 border-blue-400"
                  : "bg-gray-800 border-blue-400"
                  } ${index % 2 === 0 ? "md:ml-auto" : "md:mr-auto"}`}
              >
                <h3
                  className={
                    darkMode
                      ? "text-2xl font-bold text-blue-600"
                      : "text-2xl font-bold text-blue-300"
                  }
                >
                  {exp.title}
                </h3>

                <span className="inline-block text-white text-xs font-semibold px-3 py-1 rounded-full mt-2 bg-gradient-to-r from-yellow-400 to-orange-500 bg-opacity-90">
                  {exp.level}
                </span>

                <h4
                  className={
                    darkMode
                      ? "text-lg font-semibold text-gray-700 mt-2"
                      : "text-lg font-semibold text-white mt-2"
                  }
                >
                  {exp.company === "Planon Software Services Pvt Ltd" ? (
                    <a
                      href="https://planonsoftware.com/us/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="underline hover:text-blue-500"
                    >
                      {exp.company}
                    </a>
                  ) : exp.company === "GeeksForGeeks" ? (
                    <a
                      href="https://www.geeksforgeeks.org/user/nikhilgattu16/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="underline hover:text-blue-500"
                    >
                      {exp.company}
                    </a>
                  ) : exp.company ===
                    "University Information & Technology, Service Desk" ? (
                    <a
                      href="https://uit.oregonstate.edu/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="underline hover:text-blue-500"
                    >
                      {exp.company}
                    </a>
                  ) : (
                    exp.company
                  )}
                </h4>

                <p
                  className={
                    darkMode ? "text-sm text-gray-500" : "text-sm text-gray-400"
                  }
                >
                  {exp.location} | {exp.duration}
                </p>

                <ul className="list-disc list-inside mt-4 space-y-2">
                  {exp.points.map((point, idx) => (
                    <li
                      key={idx}
                      className={darkMode ? "text-gray-600" : "text-gray-300"}
                    >
                      {point}
                    </li>
                  ))}
                </ul>
              </motion.div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Experience;
